import {
    IExecuteWaitForHybridGameStepOptions,
    IHybridTouchIdFeature,
    IMarketingObject, IOrbitHybridService,
    NyxHybridParams
} from "./hybrid.service.interface";
import {ServiceBase} from "../ServiceBase";
import {Nullable, NullableUndefinedString} from "../../../common/types/nullable-types";
import {VersionNumber} from "../../../utils/version-number";
import {Check} from "@sparkware/app-utils";


export class HybridService extends ServiceBase implements IOrbitHybridService {
    prepareGameUrl(gameType: number, gameUrl: string, pathname: string = ''): string {
        return this.services.sdk.hybrid.prepareGameUrl(gameType, gameUrl, pathname);
    }

    getCompiledGameVersion(gameType: number): NullableUndefinedString {
        return this.services.sdk.hybrid.getCompiledGameVersion(gameType);
    }

    async executeWaitForHybridGameStep(options: IExecuteWaitForHybridGameStepOptions): Promise<void> {
        await this.services.sdk.hybrid.executeWaitForHybridGameStep(options);
    }

    navigateToOnDemandStandalone(gameType: number, companyName: string, url: string): boolean {
        return this.services.sdk.hybrid.navigateToOnDemandStandalone(gameType, companyName, url);
    }
    isNativeSupportSecondWebView(): boolean {
        return this.services.sdk.hybrid.isNativeSupportSecondWebView();
    }

    isOnDemandHtmlGame(gameType: number): boolean {
        return this.services.sdk.hybrid.isOnDemandHtmlGame(gameType);
    }

    isOnDemandStandalone(gameType: number, companyName: string): boolean {
        return this.services.sdk.hybrid.isOnDemandStandalone(gameType, companyName);
    }

    getOnDemandOrigin(): string {
        return this.services.sdk.hybrid.getOnDemandOrigin();
    }

    isSchemeSupported() : boolean {
        return this.services.sdk.hybrid.isSchemeSupported()
    }

    isLocalGameLauncherSupported() : boolean {
        return this.services.sdk.hybrid.isLocalGameLauncherSupported()
    }

    setGamescheme(gameschcme: string){
        this.services.sdk.hybrid.setGamescheme(gameschcme);
    }

    showAlert(message: string): void {
        this.services.sdk.eventsTrigger.showHybridAlert(message);
    }

    openExternalLink(url: string): void {
        this.services.sdk.hybrid.openExternalLink(url);
    }

    isNyxIframeSupported(): boolean {
        return this.services.sdk.hybrid.isNyxIframeSupported();
    }

    getNyxLocalHostUrl(params: NyxHybridParams, gameType:string): Promise<string> {
        return this.services.sdk.hybrid.getNyxLocalHostUrl(params, gameType);
    }

    closeSecondWebView(): void {
        return this.services.sdk.hybrid.closeSecondWebView();
    }

    getInfoForDisplay(): Promise<string> {
        return this.services.sdk.hybrid.getInfoForDisplay();
    }

    openMail(body: string): void {
        this.services.sdk.hybrid.openMail(body);
    }

    getTouchIDFeaturer(): IHybridTouchIdFeature {
        return this.services.sdk.hybrid.getTouchIDFeaturer();
    }

    isDeviceTouchEnable(): Promise<boolean> {
        return this.services.sdk.hybrid.isDeviceTouchEnable();
    }

    isOpenSettingSupported(): Promise<boolean> {
        return this.services.sdk.hybrid.isOpenSettingSupported();
    }
    openTouchIdSettings(): Promise<boolean> {
        return this.services.sdk.hybrid.openTouchIdSettings();
    }

    isDebugMode(): boolean {
        return this.services.sdk.hybrid.isDebugMode();
    }

    clearToken(): void {
        return this.services.sdk.hybrid.clearToken();
    }

    async displayWebView(timeout: number): Promise<void> {
        await this.services.sdk.hybrid.displayWebView(timeout);
    }

    getAppMareketingData(): IMarketingObject {
        return this.services.sdk.hybrid.getAppMareketingData();
    }
    async getLexisNexisSession(marketingData: any): Promise<any> {
        return await this.services.sdk.hybrid.getLexisNexisSession(marketingData);
    }

    getAFInstall(): string {
        return this.services.sdk.hybrid.getAFInstall();
    }

    getAppVersion(): Nullable<VersionNumber> {
        let versionString = this.services.sdk.hybrid.getVersion();
        if(Check.isEmpty(versionString)) {
            return null;
        }

        versionString = versionString.split('-')[0];

        return VersionNumber.tryParse(versionString);
    }
}